var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.11127 12L3.11127 7L4.51127 5.55L7.11127 8.15V0H9.11127V8.15L11.7113 5.55L13.1113 7L8.11127 12ZM2.11127 16C1.56127 16 1.09043 15.8042 0.698767 15.4125C0.3071 15.0208 0.111267 14.55 0.111267 14V11H2.11127V14H14.1113V11H16.1113V14C16.1113 14.55 15.9154 15.0208 15.5238 15.4125C15.1321 15.8042 14.6613 16 14.1113 16H2.11127Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadWhiteIcon);
export default __webpack_public_path__ + "static/media/download-white-icon.6c40052cefd9ef937bda673125dd46d7.svg";
export { ForwardRef as ReactComponent };